<template>
  <a-drawer
    title="预览页面"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
    width="450"
  >
    <div class="phone-box">
      <iframe
        name="pageIframe"
        id="pageIframe"
        frameborder="0"
        width="100%"
        height="100%"
        :src="`${url}?editing=true`"
        allowFullScreen="true"
      />
    </div>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #394555',
        padding: '10px 16px',
        background: '#394555',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button :style="{ marginRight: '8px' }" @click="onClose">
        取消
      </a-button>
      <a-button type="primary" @click="handleRefreshPreview">
        刷新页面
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
export default {
  data() {
    return {
      url: '',
      visible: false
    }
  },
  methods: {
    showModal(url) {
      this.url = url
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
    // 刷新页面效果
    handleRefreshPreview() {
      document.getElementById('pageIframe').src = this.url + '?editing=true'
    }
  }
}
</script>
<style lang="less" scoped>
.phone-box {
  width: 375px;
  height: 667px;
  background: #fff;
  overflow: hidden;
  margin: 10px auto
}
</style>
